import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledMiniLinkItem } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/mini-link-item/mini-link-item.scss";
import { useState } from "react";
import Colors from "styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR } from "styles/color-consts";
const MiniLinkItem = ({ Icon, text, link, onClick })=>{
    const [isHover, setIsHover] = useState(false);
    const toggleHover = ()=>{
        setIsHover((isHover)=>!isHover);
    };
    return /*#__PURE__*/ _jsxs(StyledMiniLinkItem, {
        onMouseLeave: toggleHover,
        onMouseEnter: toggleHover,
        onClick: onClick,
        href: link,
        className: "mini-link-item",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "icon-container",
                children: /*#__PURE__*/ _jsx(Icon, {
                    color: isHover && Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "text",
                children: text
            })
        ]
    });
};
export default MiniLinkItem;
